import { useEffect } from "react";
import { useSetParentBrowseTab } from "#use-set-parent-browse-tab";

/**
 * Declares the browse origin for a detail page that isn't reached from a sub-tab — i.e. the
 * search-card detail, which sets it to "Search" so `<BrowseNavBackButton>` reads "Search" and
 * `router.back()` returns to the search page. Writes on mount (the search-card is only ever reached
 * from the search page, so mount is the moment it becomes the origin). Sub-tab detail pages don't
 * use this: the tab-focus listener in `browse-tabs-layout` already sets `parentBrowseTab` to the
 * focused tab's title.
 */
export function useDeclareParentBrowseTab(label: string) {
  const setParentBrowseTab = useSetParentBrowseTab();
  useEffect(() => {
    setParentBrowseTab(label);
  }, [label, setParentBrowseTab]);
}
